/**
 * On custom-domain hosts the character page lives at '/'. Everything else
 * (dashboard, auth, marketing SSR pages) belongs to mychar.gg and is
 * redirected home. Prerendered static pages never reach this middleware; an
 * edge route in nuxt.config.ts ('nitro:init' hook) redirects those instead.
 */
export default defineNuxtRouteMiddleware((to) => {
  const { isCustomDomain, customDomainUsername } = useCustomDomain()
  if (!isCustomDomain.value) return

  if (to.path === '/') return

  // Dedupe: the character page is canonical at '/'
  if (to.path === `/${customDomainUsername.value}`) {
    return navigateTo('/', { redirectCode: 301 })
  }

  return navigateTo('/', { redirectCode: 302 })
})
